import React, { useId } from 'react';

const HelportBrandLogo = ({ className = '', showTagline = true }) => {
  const rawId = useId().replace(/:/g, '');
  const wordGradId = `helport-word-grad-${rawId}`;
  const markGradId = `helport-mark-grad-${rawId}`;
  const accentGradId = `helport-accent-grad-${rawId}`;

  return (
    <div className={`helport-brand-logo ${className}`.trim()} role="img" aria-label="Helport Human Resources">
      <svg
        viewBox="0 0 320 84"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="helport-brand-logo__svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id={wordGradId} x1="68" y1="18" x2="310" y2="46" gradientUnits="userSpaceOnUse">
            <stop stopColor="#E8FFF4" />
            <stop offset="0.42" stopColor="#9AF0C8" />
            <stop offset="1" stopColor="#5BC4F7" />
          </linearGradient>
          <linearGradient id={markGradId} x1="12" y1="12" x2="52" y2="52" gradientUnits="userSpaceOnUse">
            <stop stopColor="#00D27F" />
            <stop offset="1" stopColor="#38BDF8" />
          </linearGradient>
          <linearGradient id={accentGradId} x1="68" y1="0" x2="188" y2="0" gradientUnits="userSpaceOnUse">
            <stop stopColor="#00D27F" />
            <stop offset="1" stopColor="#38BDF8" stopOpacity="0.15" />
          </linearGradient>
        </defs>

        <rect x="8" y="14" width="48" height="48" rx="14" fill="rgba(8, 16, 28, 0.72)" stroke={`url(#${markGradId})`} strokeWidth="1.5" />
        <path
          d="M22 26v28M22 40h20M42 26v28"
          stroke={`url(#${markGradId})`}
          strokeWidth="4.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <text
          x="68"
          y="44"
          fill={`url(#${wordGradId})`}
          fontFamily="'Segoe UI', 'Helvetica Neue', Arial, sans-serif"
          fontSize="31"
          fontWeight="700"
          letterSpacing="5.5"
        >
          HELPORT
        </text>

        <rect x="68" y="52" width="120" height="2.5" rx="1.25" fill={`url(#${accentGradId})`} />

        {showTagline && (
          <text
            x="68"
            y="68"
            fill="#94A3B8"
            fontFamily="'Segoe UI', 'Helvetica Neue', Arial, sans-serif"
            fontSize="10.5"
            fontWeight="600"
            letterSpacing="3.4"
          >
            HUMAN RESOURCES
          </text>
        )}
      </svg>
    </div>
  );
};

export default HelportBrandLogo;
